import { ReactNode } from 'react'

import { AppLink } from '@/shared/lib/router'

import { env } from '@/env'

import { useActiveNav } from '@/shared/hooks/useActiveNav'
import { cn } from '@/shared/lib/utils'

type ShellMainNavItemProps = {
  href: string
  children: ReactNode
  disabled?: boolean
  ariaLabel?: string
}

const isDev = env.NEXT_PUBLIC_PGEE_APP_ENV === 'development'

export const ShellMainNavItem = ({
  href,
  children,
  disabled,
  ariaLabel
}: ShellMainNavItemProps) => {
  const isActive = useActiveNav(href)

  return (
    <AppLink
      href={href}
      aria-label={ariaLabel}
      className={cn(
        'flex items-center gap-3 px-2 py-1 lg:px-3 lg:py-2 h-[52px] font-sans font-medium rounded-lg border-2 border-transparent cursor-pointer aria-disabled:opacity-50 aria-disabled:cursor-not-allowed aria-disabled:pointer-events-none',
        'text-gray-200 bg-transparent aria-disabled:text-gray-400',
        'transition-colors duration-200 hover:bg-gray-800 hover:text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-foreground',
        isActive &&
          'text-primary-foreground border-primary-foreground bg-gray-900 dark:text-primary-foreground dark:border-primary-foreground'
      )}
      aria-current={isActive ? 'page' : undefined}
      aria-disabled={isDev ? false : disabled}
    >
      {children}
    </AppLink>
  )
}
